import { CCtaBoxFragments } from './c-cta-box'
import { CFullWidthTestimonialFragments } from './c-full-width-testimonial'

export const CCustomComponentsBlogFragments = {
  field: `
    fragment customComponentsBlog on customComponentsBlog_MatrixField {
      ... on customComponentsBlog_counter_Entry {
        typeHandle
      }
      ...customComponentsBlog_ctaBox
      ... on customComponentsBlog_ctaBox2_Entry {
        typeHandle
      }
      ... on customComponentsBlog_findADoctor_Entry {
        typeHandle
      }
      ...customComponentsBlog_fullWidthTestimonial
      ... on customComponentsBlog_stats_Entry {
        typeHandle
      }
    }
    ${CCtaBoxFragments.customComponentsBlogField}
    ${CFullWidthTestimonialFragments.customComponentsBlogField}
  `,
}
